import React, { useState } from "react";
import { Dialog } from "@mui/material";

import { ReactComponent as QuestionMarkIcon } from "assets/img/svg/QuestionMarkConfirmationDialog.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import ATextarea from "views/pages/manage/common/formFeilds/customInput/ATextarea";

const RejectDialog = ({
  isOpen,
  setRejectionDialog,
  rejectionHandler,
  title = "Are you sure you want to reject?",
  subheading = "Please enter a reason for rejection",
}) => {
  const [remark, setRemarks] = useState("");

  const closeDialog = () => {
    setRemarks("");
    setRejectionDialog({ isOpen: false, data: null });
  };

  return (
    <Dialog open={isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <QuestionMarkIcon />
          <CrossIcon onClick={closeDialog} />
        </div>

        <div className="header">{title}</div>
        <div className="subHeading">{subheading}</div>

        <div className="mt-4">
          <div className="mb-2">Remarks*</div>

          <ATextarea
            placeholder="Add a comment..."
            rows={4}
            style={{ height: "90px" }}
            value={remark}
            onChange={(value) => setRemarks(value)}
            maxlength="100" // char limit: 100
          />
        </div>

        <div className="mt-4">
          <button className="no-ml-btn" onClick={closeDialog}>
            Go back
          </button>

          <AButton
            className="reject-btn px-5"
            variant="danger_filled"
            disabled={!remark.length}
            onClick={() => {
              rejectionHandler(remark);
            }}
            style={{ width: "max-content" }}
          >
            Yes, Reject
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};

export default RejectDialog;
